<template>
  <div
    :class="[
      question?.is_type == 'group'
        ? 'mb-2'
        : showValidationErrors && required && selection === ''
          ? 'relative mb-5'
          : 'mb-2',
    ]"
  >
    <div
      v-if="question?.show_subject !== false"
      class="-mb-4 flex items-start"
    >
      <p
        v-if="!question?.is_html_subject"
        class="text-dark-blue"
      >
        {{ subject }}
      </p>
      <div
        v-else
        class="text-sm"
        v-html="question?.subject"
      />
      <slot />
    </div>
    <div class="inherit-margin">
      <dropdown-select
        :options="orderedOptions"
        :default="defaultSelection"
        :label="question.description"
        :is-object="true"
        :emit-on-mount="false"
        @input="handleDropdown"
      />
    </div>
    <div
      v-if="showValidationErrors && required && selection === ''"
      class="absolute -bottom-5 pl-1 text-3xs text-red-500"
    >
      This field is required.
    </div>
  </div>
</template>

<script>
import DropdownSelect from '@/components/DropdownSelectTax.vue';
import _ from 'lodash';

export default {
  name: 'Select',
  components: {
    DropdownSelect,
  },
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    currentTaxFormId: Number,
    onboardingPacketId: Number,
    setTaxAnswers: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
    currentAnswerObject: [Object, Boolean],
  },
  emits: ['child-check', 'group-check'],
  data() {
    return {
      selection: '',
      defaultSelection: '',
    };
  },
  computed: {
    orderedOptions() {
      let noVal = { id: null, value: 'Select an option...', order: 0 };
      let values = [noVal, ...this.question.options];
      return _.orderBy(values, 'order');
      // return _.orderBy(this.question.options, 'order')
      // return orderedOptions.map(el => (el.value))
    },
    currentTaxForm() {
      return this.$store.state.taxQuestions.current_tax_form;
    },
    showValidationErrors() {
      if (this.currentTaxForm?.length < 1) return false;
      return this.$store.state.taxQuestions.show_validation_errors[
        this.currentTaxForm
      ];
    },
  },
  mounted() {
    this.emitForComparison(
      this.defaultSelection == ''
        ? this.orderedOptions?.[0]?.id
        : this.defaultSelection?.id
    );
  },
  created() {
    // let recentAnswer = this.question?.most_recent_previous_answer;
    if (this.currentAnswerObject && this.currentAnswerObject !== false) {
      this.selection =
        this.currentAnswerObject?.answer_options?.[0]?.tax_question_option_id;
      if (this.question?.options?.length > 0) {
        this.defaultSelection = this.question.options.filter(
          (el) => el.id == this.selection
        )[0];
      }
      if (this.selection) {
        this.presetSavedAnswer();
      }
    }
  },
  methods: {
    handleDropdown(item) {
      this.selection = item?.id;
      let body = null;
      if (this.selection) {
        body = {
          onboarding_packet_id: this.onboardingPacketId,
          tax_form_id: this.currentTaxFormId,
          tax_question_id: this.question_id,
          tax_answer_options_attributes: [
            { tax_question_option_id: this.selection },
          ],
        };
      }

      this.setTaxAnswers(body);
      if (this.required) {
        this.selection
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.selection);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (child?.evaluation_js?.length > 0 && child?.tax_question_id > 0) {
            this.$emit(
              'child-check',
              child.tax_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
      if (this.question?.group_parent_id !== null) {
        this.$emit(
          'group-check',
          this.question?.id,
          this.question?.group_parent_id,
          value
        );
      }
    },
    presetSavedAnswer() {
      let body = {
        onboarding_packet_id: this.onboardingPacketId,
        tax_form_id: this.currentTaxFormId,
        tax_question_id: this.question_id,
        tax_answer_options_attributes: [
          { tax_question_option_id: this.selection },
        ],
      };

      this.setTaxAnswers(body);
      if (this.required) {
        this.selection
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.selection);
    },
  },
};
</script>
